import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class PromotionService {

  promoMessageClosed = new Subject<string>()

  promoMessageChanged = new Subject<any>()

  constructor() { }

  closeMessage() {
    this.promoMessageClosed.next('promotion message closed')
  }

  promotionUpdated(promotionMessage) {
    if (promotionMessage) {
      this.promoMessageChanged.next({message: 'promotion message updated', obj: promotionMessage})
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/promotion.service.ts